import { defineStore } from "pinia";

import axios from "axios";
import { useNotificationsStore } from "@/store/notifications";
import { useLK } from "@/controllerLK/LKstore";
import { t } from "@/controllerLK/AvalLocalization";

export const useReportStore = defineStore({
    id: "reportStore",
    state: () => ({
        reportList: [],
    }),
    getters: {},
    actions: {
        async getReportFiles() {
            const LKStore = useLK();

            this.reportList = (await axios.get( process.env.VUE_APP_BASE_API + `Files/list/${LKStore.project.id}/Reports`)).data;
            return this.reportList;
        },
        async uploadFile(files, partition = "Reports") {
            const LKStore = useLK();
            const notificationsStore = useNotificationsStore();

            const url = process.env.VUE_APP_BASE_API + `Files/upload/${LKStore.project.id}/${partition}`;
            try {
                await axios.post(url, files);
                notificationsStore.createNotify(t("toast.file_upload_success"), "success");
            } catch (e) {
                if (e.response.status === 413) {
                    notificationsStore.createNotify(t("toast.file_size_error"), "error");
                } else {
                    notificationsStore.createNotify(t("toast.file_upload_error"), "error");
                }
            }
        },
        async deleteFile(fileName, partition = "Reports") {
            const notificationStore = useNotificationsStore();
            const LKStore = useLK();
            const url = process.env.VUE_APP_BASE_API + `Files/${LKStore.project.id}/${partition}/${fileName}`;

            try {
                await axios.delete(url);
                notificationStore.createNotify(t("toast.file_delete_success"), "success");
            } catch (e) {
                notificationStore.createNotify(t("toast.file_delete_error"), "error");
            }
        },

        async downloadFile(fileName, partition = "Reports") {
            const notificationStore = useNotificationsStore();
            const LKStore = useLK();
            const url = process.env.VUE_APP_BASE_API + `Files/download/${LKStore.project.id}/${partition}/${fileName}`;

            try {
                const response = await axios.get(url, { responseType: "blob" });

                const fileUrl = window.URL.createObjectURL(response.data);
                const a = document.createElement("a");
                a.href = fileUrl;
                a.target = "_blank";
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(fileUrl);
            } catch (e) {
                notificationStore.createNotify(t("toast.file_download_error"), "error");
            }

        }
    },
});
